<template>
  <div class="container-blue flex-col flex container-box">
    <div v-if="title" class="flex blue-gradient banner">
      <span class="text-white p-4 ml-2 lg:ml-0 font-bold text-base lg:leading-5">
        {{ title }}
      </span>
    </div>
    <div class="p-6 lg:p-4 flex flex-col flex-grow bg-white">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseBox",
  props: ["title"],
};
</script>
<style scoped>
.banner {
  border-top-left-radius: 1px;
  border-top-right-radius: 1px;
}
.container-box {
  @apply bg-main-dark;
}
</style>